import { useEffect, useState } from 'react'
import { useRouteMatch, useLocation, useHistory } from 'react-router'
import { Link } from 'react-router-dom'
import { Button, Checkbox, Dropdown, Input, Layout, List, Modal, Menu, Space, Tag} from 'antd'
import { BranchesOutlined, EllipsisOutlined } from '@ant-design/icons'
import Feather from '@sysunite/react-feather'
import moment from 'moment'
import { setBranches } from 'Actions/branches'
import { connect } from 'react-redux'
import './List.scss'

{ Search } = Input

BranchList = ({ branches, currentBranch, setBranches, displayConfigEnabled }) ->

  [loading, setLoading] = useState(false)
  [search, setSearch] = useState('')
  [selection, setSelection] = useState([])
  [branchCommits, setBranchCommits] = useState([])
  [scheduledForDeletion, setScheduledForDeletion] = useState({})

  useEffect( ->
    ( ->
      all = await Weaver.getInstance()
        .currentProject()
        .listCommits(9999, 0)
      setBranchCommits(all.filter(({ branches }) -> branches.length > 0 ))
    )()
    undefined
  , [])

  useEffect(->
    (->
      setLoading(true)
      setBranches(await Weaver.Branch.list())
      setLoading(false)
    )()
    undefined
  , [])

  history = useHistory()
  { params: { spaceId }} = useRouteMatch()

  deleteBranch = (branch) ->
    Modal.confirm({
      title: "You are about to delete #{branch.name()}"
      content: "Are you sure you want to delete #{branch.name()}?"
      onOk: (close) ->
        await branch.destroy()
        setBranches(
          branches.filter((b) ->
            b.id() isnt branch.id()
          )
        )
        close
      okText: 'Yes'
      okType: 'danger'
      cancelText: 'No'
    })

  ExtraActions = ({ branch }) ->
    menu = (
      <Menu data-testid="#{branch.id()}-branch-actions-list">
        <Menu.Item
          data-testid="protect-#{branch.id()}"
          disabled={branch.isProtected()}
          onClick={ ->
            await branch.protect()
            setBranches([branches...])
            setScheduledForDeletion({
              scheduledForDeletion...
              [branch.id()]: false
            })
          }
        >
          Protect
        </Menu.Item>
        <Menu.Item
          data-testid="unprotect-#{branch.id()}"
          disabled={!branch.id() is 'main' or !branch.isProtected()}
          onClick={ ->
            await branch.unprotect()
            setBranches([branches...])
          }
        >
          Unprotect
        </Menu.Item>
        <Menu.Item
          data-testid="delete-#{branch.id()}"
          danger
          disabled={!branch.id() is 'main' or branch.isProtected()}
          onClick={ ->
            Modal.confirm({
              title: "You are about to delete #{branch.name()}"
              content: "Are you sure you want to delete #{branch.name()}?"
              onOk: (close) ->
                await branch.destroy()
                setBranches(
                  branches.filter((b) ->
                    b.id() isnt branch.id()
                  )
                )
                setScheduledForDeletion({
                  scheduledForDeletion...,
                  [branch.id()]: false
                })
                close()
              okText: 'Yes'
              okType: 'danger'
              cancelText: 'No'
            })
          }
        >
          Delete
        </Menu.Item>
      </Menu>
    )
    <Dropdown
      data-testid="extra-actions-dropdown-#{branch.id()}"
      overlay={menu}
      destroyPopupOnHide={true}
      disabled={branch.id() is 'main'}
    >
      <Button
        data-testid="extra-actions-#{branch.id()}"
        icon={<Feather type="more-horizontal" />}
      />
    </Dropdown>

  searchFilter = (branch) ->
    if search? and search isnt ''
      branch.name().toLowerCase().includes(search.toLowerCase())
    else
      true

  filterConfig = ->
    filteredBranches = if not displayConfigEnabled
      branches.filter((b) -> b.id() isnt '$config')
    else
      branches

  getTitle = (branch) ->
    <>
      { branch.name() }
      { <Tag color="blue" style={{ marginLeft: 5 }}>{'default'}</Tag> if branch.id() is 'main' }
      { <Tag color="green" style={{ marginLeft: 5 }}>{'protected'}</Tag> if branch.isProtected() }
      { <Tag color="orange" style={{ marginLeft: 5 }}>{'current branch'}</Tag> if branch.id() is currentBranch }
    </>

  <Layout>
    <List
      itemLayout="horizontal"
      rowKey={(branch) -> branch.id()}
      size="small"
      className="branch-list"
      dataSource={_.sortBy(_.filter(filterConfig(), searchFilter), (branch) -> branch.name())}
      loading={loading}
      style={{ margin: 20, borderRadius: 9 }}
      header={
        <div style={{ padding: '10px 20px' }}>
          Active branches
          <span style={{ float: 'right', marginTop: -5 }}>
            <Button
              type="primary"
              onClick={ -> history.push("/#{spaceId}/branches/new")}
              data-testid="create-branch-bttn"
            >
              New branch
            </Button>
            <Search
              style={{ marginLeft: 8, width: 300 }}
              placeholder="Filter branches"
              onChange={({ target: { value }}) -> setSearch(value)}
            />
            <Button
              disabled={!_.find(scheduledForDeletion, (val) -> val)}
              style={{ margin: '0 8px' }}
              type="danger"
              icon={<Feather type="trash" />}
              onClick={ ->
                Modal.confirm({
                  title: "You are about to delete these branches."
                  content: "Are you sure you want to proceed?"
                  onOk: (close) ->
                    idsToDelete = _.map(scheduledForDeletion, (val, key) -> { key, val })
                      .filter(({ val }) -> val)
                      .map(({ key }) -> key)
                    await Promise.all(idsToDelete.map((id) -> new Weaver.Branch(id).destroy()))
                    setBranches(
                      branches.filter((b) -> idsToDelete.indexOf(b.id()) is -1)
                    )
                    close()
                  okText: 'Yes'
                  okType: 'danger'
                  cancelText: 'No'
                })
              }
            />
            <Checkbox
              style={{ margin: '0 8px' }}
              onChange={({ target: { checked }}) ->
                setScheduledForDeletion(
                  branches.filter((b) ->
                    b.id() isnt 'main' and !b.isProtected()
                  ).reduce((acc, curr) ->
                    { acc..., [curr.id()]: checked }
                  , {})
                )
              }
            />
          </span>
        </div>
      }
      renderItem={(branch) -> (
        <List.Item
          key={branch.id()}
          actions={[
            <Link to="/#{spaceId}/merge-requests/new?source=#{branch.id()}">
              <Button data-testid="merge-request-#{branch.id()}">Merge request</Button>
            </Link>
            <Link to="/#{spaceId}/compare?source=#{branch.id()}">
              <Button data-testid="compare-#{branch.id()}">Compare</Button>
            </Link>
            <ExtraActions branch={branch}/>
            <Checkbox
              data-testid="#{branch.id()}-branch-checkbox"
              style={{ margin: '0 8px' }}
              disabled={branch.id() is 'main' or branch.isProtected()}
              checked={scheduledForDeletion[branch.id()]}
              onChange={({ target: { checked }}) ->
                setScheduledForDeletion({
                  scheduledForDeletion...
                  [branch.id()]: checked
                })
              }
            />
          ]}
        >
          <List.Item.Meta
            avatar={<Feather type="git-branch" style={{ fontSize: '1rem', strokeWidth: 1.3 }} />}
            title={getTitle(branch)}
            description={<CommitDetails commit={branchCommits.find((c) -> c.branches.indexOf(branch.id()) isnt -1 )} />}
          />
        </List.Item>
      )}
    />
  </Layout>

CommitDetails = ({ commit }) ->
  return <span /> unless commit
  descriptionString = """
     #{ commit.message or 'No commit message.' } · #{ moment(commit.timestamp).fromNow() }
  """
  <>
    <Feather type="git-commit" style={{ strokeWidth: 1.1 }} />
    <span style={{ marginLeft: 5 }}>{ descriptionString }</span>
  </>

export default connect(({ branches, projects }) ->
  {
    displayConfigEnabled: projects.displayConfigEnabled
    branches: branches.branches
    currentBranch: branches.currentBranch
  }
, { setBranches }
)(BranchList)
